import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { bootTheme, ThemeProvider } from "@/contexts/ThemeContext";

// Applique la classe .dark / .light AVANT le mount React → évite le flash blanc initial.
bootTheme();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </React.StrictMode>,
);
